// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.chart_holder[data-v-4a6cf21c] {\n  width: 100%;\n  height: 100%;\n  min-height: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
